import React, { useState } from "react";
import { v4 as uuid } from 'uuid';

const ToggleSetting = ({ onChange, field, value, label }) => {
  const handleChange = () => {
    onChange(field, !value);
  };
  const id = uuid();
  return (
    <div className="form-group">
      <div className="checkbox checkbox-primary">
        <input
          type="checkbox"
          checked={value || false}
          className="btn btn-primary"
          id={id}
          onChange={handleChange}
        />
        <label htmlFor={id}>
          <span>{label}</span>
        </label>
      </div>
    </div>
  );
};

export default ToggleSetting;
